import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import '../Pagination.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as actasService from '../../services/actas/actasService';
import {
  buildActaExamenMateriaDisplay,
  buildActaExamenResultadosForSave,
  classifyActasError,
  findAlumnosSinNotaPromedioCargado,
  formatActaExamenTipo,
  isActaExamenFechaActaEditable,
  seedActaExamenResultadosFromDetalle,
  toSaveActaExamenNotasPayload,
  validateActaExamenNotasPromedio,
  validateCargarActaExamenEncabezado
} from '../../services/actas/actasDto';
import { displayDate, parseDate } from '../../services/dates/dateService';
import Select from '../common/AppSelect';
import { findSelectOptionByValue } from '../../services/selectOptions';
import { ConfirmDialog } from '../common/ConfirmDialog';
import { CalendarDatePicker } from '../common/CalendarDatePicker';

const NOTA_OPTIONS = [
  { value: '0', label: 'Ausente' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' }
];

export class CargarActaExamen extends Component {
  static displayName = CargarActaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      perPage: 10,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      alumnos: [],
      materia: '',
      fechaExamen: '',
      tipoActa: '',
      id: this.props.match.params.id,
      resultados: [],
      folio: '',
      libro: '',
      fechaPromocion: null,
      alumnosPendientesIds: [],
      encabezadoPendiente: false,
      fechaPromocionPendiente: false,
      showSuccessDialog: false,
      success: false
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => actasService.listActaExamenDetalle(this.state.id, query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState)
    });
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
  }

  handleConfirmButton = () => {
    const encabezadoValido = validateCargarActaExamenEncabezado(this.state.folio, this.state.libro, {
      tipoActa: this.state.tipoActa,
      fechaPromocion: this.state.fechaPromocion
    });
    const pendientes = findAlumnosSinNotaPromedioCargado(this.state.alumnos, this.state.resultados);
    const notasValidas = validateActaExamenNotasPromedio(this.state.alumnos, this.state.resultados);
    const fechaActaEditable = isActaExamenFechaActaEditable(this.state.tipoActa);

    if (!encabezadoValido || !notasValidas) {
      let errorMessage = 'Hay alumnos sin cargar la nota promedio';
      if (!encabezadoValido && !notasValidas) {
        errorMessage = fechaActaEditable
          ? 'Debe ingresar el libro, el folio, la fecha del acta y la nota promedio de todos los alumnos'
          : 'Debe ingresar el libro, el folio y la nota promedio de todos los alumnos';
      } else if (!encabezadoValido) {
        if (fechaActaEditable && !this.state.fechaPromocion) {
          errorMessage = 'Debe ingresar el libro, el folio y la fecha del acta';
        } else {
          errorMessage = 'Debe ingresar el libro y el folio';
        }
      }

      this.setState({
        errorMessage,
        showErrorMessage: true,
        encabezadoPendiente: !encabezadoValido,
        fechaPromocionPendiente: fechaActaEditable && !this.state.fechaPromocion,
        alumnosPendientesIds: pendientes.map((alumno) => alumno.detalleActaCod)
      });
      return;
    }

    this.setState({
      showErrorMessage: false,
      errorMessage: '',
      encabezadoPendiente: false,
      fechaPromocionPendiente: false,
      alumnosPendientesIds: []
    });
    this.postNotas();
  };

  handleSuccessDialogClose = () => {
    this.setState({ showSuccessDialog: false, success: true });
  };

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWActasExamen');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleActasError(error));
  };

  handleOnChangeFolio = (e) => {
    this.setState({ folio: e.target.value, encabezadoPendiente: false });
  };

  handleOnChangeLibro = (e) => {
    this.setState({ libro: e.target.value, encabezadoPendiente: false });
  };

  handleFechaPromocion = (fecha) => {
    this.setState({ fechaPromocion: fecha, fechaPromocionPendiente: false });
  };

  isAlumnoPendiente = (detalleId) => this.state.alumnosPendientesIds.includes(detalleId);

  getResultadoEntry = (detalleId) => this.state.resultados.find((entry) => entry.id === detalleId);

  updateResultadoField = (detalleId, field, value) => {
    this.setState((prevState) => {
      const index = prevState.resultados.findIndex((entry) => entry.id === detalleId);
      const resultados = index >= 0
        ? prevState.resultados.map((entry, entryIndex) => (
          entryIndex === index ? { ...entry, [field]: value } : entry
        ))
        : [...prevState.resultados, { id: detalleId, oral: '', escrito: '', nota: '', [field]: value }];

      const alumnosPendientesIds = field === 'nota' && value
        ? prevState.alumnosPendientesIds.filter((id) => id !== detalleId)
        : prevState.alumnosPendientesIds;

      return { resultados, alumnosPendientesIds };
    });
  };

  handleNotaOral = (detalleId, option) => {
    this.updateResultadoField(detalleId, 'oral', option?.value ?? '');
  };

  handleNotaEscrito = (detalleId, option) => {
    this.updateResultadoField(detalleId, 'escrito', option?.value ?? '');
  };

  handleNotaPromedio = (detalleId, option) => {
    this.updateResultadoField(detalleId, 'nota', option?.value ?? '');
  };

  renderEditableField(label, id, value, onChange, invalid = false) {
    return (
      <div className="md-page__field">
        <label className="md-page__field-label" htmlFor={id}>{label}</label>
        <input
          id={id}
          className={`md-page__field-input${invalid ? ' md-page__field-input--invalid' : ''}`}
          type="text"
          value={value}
          disabled={this.state.loading}
          onChange={onChange}
        />
      </div>
    );
  }

  renderFechaActaEncabezadoField(fechaActaEditable) {
    const fechaDisplay = displayDate(this.state.fechaExamen);

    return (
      <div className="md-page__field">
        <label
          className="md-page__field-label"
          htmlFor={fechaActaEditable ? 'cargar-acta-examen-fecha-promocion' : undefined}
        >
          Fecha del acta
        </label>
        {fechaActaEditable ? (
          <CalendarDatePicker
            inputId="cargar-acta-examen-fecha-promocion"
            className={`md-page__field-input${this.state.fechaPromocionPendiente ? ' md-page__field-input--invalid' : ''}`}
            selected={this.state.fechaPromocion}
            onChange={this.handleFechaPromocion}
            disabled={this.state.loading}
          />
        ) : (
          <div
            className="md-page__field-readonly md-page__field-readonly--single-line"
            title={fechaDisplay}
            aria-readonly="true"
          >
            {fechaDisplay}
          </div>
        )}
      </div>
    );
  }

  renderalumnosTable(alumnos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="cargar-acta-examen-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Nota Examen Oral</th>
              <th scope="col">Nota Examen Escrito</th>
              <th scope="col">Nota Examen Promedio</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => {
              const detalleId = alumno.detalleActaCod;
              const entry = this.getResultadoEntry(detalleId);
              const rowClassName = this.isAlumnoPendiente(detalleId)
                ? 'md-cargar-acta-examen__row--pending'
                : undefined;

              return (
                <tr key={detalleId} className={rowClassName}>
                  <td>{alumno.alumnoDni}</td>
                  <td>{alumno.alumnoNombre}</td>
                  <td>
                    <Select
                      options={NOTA_OPTIONS}
                      disabled={this.state.loading}
                      placeholder="Seleccioná la nota"
                      value={findSelectOptionByValue(NOTA_OPTIONS, entry?.oral)}
                      onChange={(option) => this.handleNotaOral(detalleId, option)}
                    />
                  </td>
                  <td>
                    <Select
                      options={NOTA_OPTIONS}
                      disabled={this.state.loading}
                      placeholder="Seleccioná la nota"
                      value={findSelectOptionByValue(NOTA_OPTIONS, entry?.escrito)}
                      onChange={(option) => this.handleNotaEscrito(detalleId, option)}
                    />
                  </td>
                  <td>
                    <Select
                      options={NOTA_OPTIONS}
                      disabled={this.state.loading}
                      placeholder="Seleccioná la nota"
                      value={findSelectOptionByValue(NOTA_OPTIONS, entry?.nota)}
                      onChange={(option) => this.handleNotaPromedio(detalleId, option)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-aex" />;
    }

    const listLoading = this.state.loading && this.state.paginationData.length === 0;
    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : (
        <>
          <div className="md-cargar-acta-examen__confirm-bar">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={this.state.loading}
            >
              Confirmar
            </button>
          </div>
          {this.renderalumnosTable(this.state.paginationData)}
        </>
      );

    const materiaDisplay = this.state.materia.trim();
    const fechaActaEditable = isActaExamenFechaActaEditable(this.state.tipoActa);

    return (
      <div className="md-page md-cargar-acta-examen">
        <Link className="md-page__back-link" to="/md-aex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 id="cargar-acta-examen-title" className="md-page__title">
            Cargar Resultados de Acta de Examen
          </h1>
        </div>
        <p className="md-page__subtitle">
          {fechaActaEditable
            ? 'Complete libro, folio y fecha del acta, cargue la nota promedio de cada alumno y confirme para guardar.'
            : 'Complete libro y folio, cargue la nota promedio de cada alumno y confirme para guardar el acta.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
        </div>

        <div className="md-page__form-card md-cargar-acta-examen__metadata-card">
          <div className="md-page__field md-page__field--inline-readonly">
            <span className="md-page__field-label">Materia</span>
            <div
              className="md-page__field-readonly md-page__field-readonly--single-line"
              title={materiaDisplay}
            >
              {materiaDisplay}
            </div>
          </div>
          <div className="md-page__field md-page__field--inline-readonly">
            <span className="md-page__field-label">Tipo de acta</span>
            <div className="md-page__field-readonly md-page__field-readonly--single-line">
              {formatActaExamenTipo(this.state.tipoActa)}
            </div>
          </div>
        </div>

        <div className="md-page__form-card md-cargar-acta-examen__encabezado-card">
          <p className="md-page__form-section-title">Encabezado del acta</p>
          <div className="md-page__form-card--grid md-cargar-acta-examen__encabezado-grid">
            {this.renderFechaActaEncabezadoField(fechaActaEditable)}
            {this.renderEditableField(
              'Libro',
              'cargar-acta-examen-libro',
              this.state.libro,
              this.handleOnChangeLibro,
              this.state.encabezadoPendiente
            )}
            {this.renderEditableField(
              'Folio',
              'cargar-acta-examen-folio',
              this.state.folio,
              this.handleOnChangeFolio,
              this.state.encabezadoPendiente
            )}
          </div>
        </div>

        {contents}

        {!this.state.loading && this.state.pageCount > 1 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              forcePage={this.state.forcePage}
              containerClassName="pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        {this.renderSuccessDialog()}
      </div>
    );
  }

  renderSuccessDialog() {
    return (
      <ConfirmDialog
        open={this.state.showSuccessDialog}
        title="Acta cargada"
        message="El acta se guardó correctamente."
        confirmLabel="Confirmar"
        showCancel={false}
        variant="primary"
        onConfirm={this.handleSuccessDialogClose}
        onCancel={this.handleSuccessDialogClose}
      />
    );
  }

  handleActasError(error) {
    const outcome = classifyActasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false
    });
  }

  async populateData() {
    try {
      actasService.clearActaExamenDetalleCache(this.state.id);
      const returnModel = await actasService.getActaExamenDetalle(this.state.id);
      actasService.seedActaExamenDetalleCache(this.state.id, returnModel);
      const first = returnModel[0];
      const resultados = seedActaExamenResultadosFromDetalle(returnModel);

      this.setState({
        alumnos: returnModel,
        folio: first?.actaExamenFolio != null ? String(first.actaExamenFolio) : '',
        libro: first?.actaExamenLibro != null ? String(first.actaExamenLibro) : '',
        materia: buildActaExamenMateriaDisplay(first),
        fechaExamen: first?.mesaExamenFechaExamen ?? '',
        fechaPromocion: parseDate(first?.fechaActaPromocion || first?.mesaExamenFechaExamen),
        tipoActa: first?.actaExamenTipo ?? '',
        resultados,
        alumnosPendientesIds: [],
        encabezadoPendiente: false,
        fechaPromocionPendiente: false
      });
      await this.grid.load();
    } catch (error) {
      this.handleActasError(error);
    }
  }

  async postNotas() {
    this.setState({ loading: true });
    try {
      await actasService.saveActaExamen(toSaveActaExamenNotasPayload({
        folio: this.state.folio,
        libro: this.state.libro,
        actaId: this.state.id,
        tipoActa: this.state.tipoActa,
        fechaPromocion: this.state.fechaPromocion,
        resultados: buildActaExamenResultadosForSave(this.state.alumnos, this.state.resultados)
      }));
      this.setState({ loading: false, showSuccessDialog: true });
    } catch (error) {
      this.handleActasError(error);
    }
  }
}
